import { Injectable } from '@angular/core';
import { ApplicationApiClientAccess } from '@nk/access-block';
import { Observable } from 'rxjs';

export interface AccountsTemplate {
  field_name: string;
  accounts_border_bottom: boolean;
  accounts_strong: boolean;
  accounts_upper: boolean;
  accounting_year: boolean;
  is_text: boolean;
  is_spacer: boolean;
  is_date: boolean;
  is_ratio: boolean;
}
@Injectable()
export class CompanyAccountsService {
  constructor(private _applicationApiAccess: ApplicationApiClientAccess) {}

  public getAccountsTemplate(): Observable<
    {
      accounts_details_template: AccountsTemplate[];
      balance_sheet_template: AccountsTemplate[];
      income_statement_template: AccountsTemplate[];
      accounts_highlights_template: AccountsTemplate[];
    }[]
  > {
    return this._applicationApiAccess.get('accounts-template');
  }
}
